// src/components/RegistraPresenza.js
import React, { useState } from 'react';
import { api } from '../utils/api';

const RegistraPresenza = () => {
  const [loading, setLoading] = useState(false);
  const [loadingUscita, setLoadingUscita] = useState(false);

  const registraEntrata = async (tipo) => {
    if (!tipo) return;
    console.log('⏺️ Invio registrazione:', tipo);
    setLoading(true);

    try {
      await api.post('/registra-entrata', { tipo });
      alert(`✅ Entrata ${tipo} registrata!`);
    } catch (error) {
      console.error('❌ Errore registrazione:', error);
      if (error.response?.status === 403 && error.response?.data?.message) {
        alert(`❌ ${error.response.data.message}`);
      } else if (error.response?.data?.error) {
        alert(`❌ ${error.response.data.error}`);
      } else {
        alert('❌ Errore durante la registrazione.');
      }
    } finally {
      setLoading(false);
    }
  };

  const registraUscita = async (tipo, forza = false) => {
    if (!tipo) return;
    setLoadingUscita(true);
    try {
      await api.post('/registra-uscita', { tipo, forza });
      alert(`✅ Uscita ${tipo} registrata!`);
    } catch (error) {
      if (error.response?.status === 409 && error.response?.data?.needsConfirmation) {
        const conferma = window.confirm(`${error.response.data.message}\nSe premi OK sovrascrivi, Annulla per lasciare invariato.`);
        if (conferma) {
          setLoadingUscita(false);
          return registraUscita(tipo, true);
        }
      } else if (error.response?.data?.message) {
        alert(`❌ ${error.response.data.message}`);
      } else if (error.response?.data?.error) {
        alert(`❌ ${error.response.data.error}`);
      } else {
        alert('❌ Errore durante la registrazione dell\'uscita.');
      }
    } finally {
      setLoadingUscita(false);
    }
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      <div
        style={{
          display: 'flex',
          gap: '30px',
          flexWrap: 'wrap',
          alignItems: 'flex-start',
        }}
      >
        <div>
          <h3>📝 Registra Entrata</h3>
          <button
            onClick={() => registraEntrata('mattina')}
            disabled={loading}
            style={{ marginRight: '10px' }}
          >
            ☀️ Mattina
          </button>
          <button onClick={() => registraEntrata('pomeriggio')} disabled={loading}>
            🌙 Pomeriggio
          </button>
        </div>

        <div>
          <h3>🚪 Registra Uscita</h3>
          <button
            onClick={() => registraUscita('mattina')}
            disabled={loadingUscita}
            style={{ marginRight: '10px' }}
          >
            ☀️ Mattina
          </button>
          <button onClick={() => registraUscita('pomeriggio')} disabled={loadingUscita}>
            🌙 Pomeriggio
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistraPresenza;
